<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page" v-else-if="showModuloForm === true">
    <v-row class="mt-n5">
      <v-col cols="12" md="8">
        <Panel lineColor="var(--primary-color)">
          <template v-slot:options v-if="showPrint">
            <FormButtonGroup align="end" spaced>
              <FormButton
                text="Detalhamento"
                type="secondario"
                @click="detailDialog = true"
              />
              <FormButton
                text="Eventos do pedido"
                type="secondario"
                @click="getLogs()"
              />
              <FormButton
                text="Imprimir"
                type="primario"
                :disabled="isLoadingPrint"
                @click="printOrder()"
              />
            </FormButtonGroup>
          </template>

          <v-row no-gutters>
            <h4 class="text-start mt-1">
              Detalhes do pedido - {{ pedido.numpedido }}
            </h4>
            <v-chip
              :color="getStatusPedidoColor(pedido.statuspedido)"
              class="ml-auto font-weight-bold"
            >
              <span v-if="pedido.statuspedido == 'AGUARDANDOPAGAMENTO'">
                <span v-if="pedido.pagamento_pendente">
                  <span v-if="getPagamentoDebito">
                    Pendente autorização do banco
                  </span>
                  <span v-else>Pagamento em análise</span>
                </span>
                <span v-else>{{ getStatusPedido(pedido.statuspedido) }}</span>
              </span>
              <span v-else>{{ getStatusPedido(pedido.statuspedido) }}</span>
            </v-chip>
          </v-row>
          <LineDivider />
          <v-card flat outlined>
            <v-simple-table class="text-start">
              <tbody>
                <tr>
                  <td class="font-weight-bold" width="25%">Hora da compra</td>
                  <td>{{ pedido.datapedido | formatDateTime(getTimeZone) }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Total do pedido</td>
                  <td>{{ pedido.totalliquido | formatMoney }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Nome do cliente</td>
                  <td>
                    {{ pedido.nomecliente }}
                    <span class="ml-3" v-if="pedido.id_cliente_erp">
                      - ({{ pedido.id_cliente_erp }})</span
                    >
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">CPF/CNPJ do cliente</td>
                  <td>{{ pedido.doccliente }}</td>
                </tr>
                <tr v-if="pedido && pedido.documento_adicional">
                  <td class="font-weight-bold">
                    Documento adicional do cliente
                  </td>
                  <td>{{ pedido.documento_adicional }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">E-mail do cliente</td>
                  <td>{{ pedido.emailcliente }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Telefone</td>
                  <td>
                    Tel:. {{ pedido.telefone }}
                    <v-icon
                      class="ml-3 font-weight-bold"
                      size="18"
                      color="green"
                      @click="callWhatsapp(pedido.telefone)"
                    >
                      fab fa-whatsapp
                    </v-icon>
                  </td>
                </tr>
                <tr v-if="commerceAtivo">
                  <td class="font-weight-bold">Forma de pagamento</td>
                  <td>
                    <v-row no-gutters v-if="showPrint">
                      <FormSelect
                        class="mt-3"
                        v-model="pedido.dadospedido.formaPagamento.idformapagto"
                        @input="changePaymentMethod"
                        :options="formasPagamento"
                        :disabled="!formaPgtoShow"
                        dense
                        :messages="
                          formaPgtoExiste
                            ? ''
                            : 'Essa forma de pagamento não existe mais. Revise esse campo.'
                        "
                      />
                      <FormButton
                        icon
                        class="mx-3 mt-4"
                        @click="formaPgtoShow = !formaPgtoShow"
                      >
                        <v-icon size="18" color="primario">
                          fa-edit
                        </v-icon>
                      </FormButton>
                    </v-row>
                    <span v-else-if="getFormaPagamento.text">{{
                      getFormaPagamento.text
                    }}</span>
                  </td>
                </tr>
                <tr
                  v-if="
                    pedido.statuspedido == 'AGUARDANDOPAGAMENTO' &&
                      !getPagamentoBoleto
                  "
                >
                  <td class="font-weight-bold">Confiança do pedido</td>
                  <td class="">
                    <FormRadioGroup
                      class="ma-0 mb-n5"
                      v-model="pedido.dadospedido.manualPaymentVerified"
                      :radios="paymentManual"
                      @change="setPedidoVerificadoManualmente"
                    >
                    </FormRadioGroup>
                  </td>
                </tr>
                <tr
                  v-if="
                    pedido.statuspedido == 'AGUARDANDOPAGAMENTO' &&
                      getBloqueioPagamento.ativo
                  "
                >
                  <td class="font-weight-bold">Bloqueio do pagamento</td>
                  <td>
                    <v-row>
                      <v-col cols="auto">
                        <p class="mb-0">Pagamento com bloqueio ativo</p>
                        <p class="mb-0 red--text">
                          {{ getBloqueioPagamento.log }}
                        </p>
                      </v-col>
                      <v-col>
                        <FormButton
                          class="float-end ml-auto"
                          type="error"
                          @click="desbloqueioPagamento()"
                        >
                          Desativar bloqueio
                        </FormButton>
                      </v-col>
                    </v-row>
                  </td>
                </tr>
                <tr v-if="commerceAtivo">
                  <td class="font-weight-bold">Parcelamento</td>
                  <td>
                    <v-row no-gutters v-if="showPrint">
                      <FormSelect
                        class="mt-3"
                        v-model="
                          pedido.dadospedido.formaPagamento.quantParcelas
                        "
                        @input="changePaymentMethod"
                        :options="parcelas"
                        :disabled="!parcelaShow"
                        dense
                      />
                      <FormButton
                        icon
                        class="mx-3 mt-4"
                        @click="parcelaShow = !parcelaShow"
                        v-if="showPrint"
                      >
                        <v-icon size="18" color="primario">
                          fa-edit
                        </v-icon>
                      </FormButton>
                    </v-row>
                    <span v-else-if="getParcela.text">{{
                      getParcela.text
                    }}</span>
                  </td>
                </tr>
                <tr
                  v-if="
                    pedido.dadospedido.enderecofaturamento &&
                      pedido.dadospedido.enderecofaturamento.rua &&
                      pedido.dadospedido.enderecofaturamento.bairro
                  "
                >
                  <td class="font-weight-bold">Endereço de faturamento</td>
                  <td>
                    <v-row no-gutters>
                      <p class="mt-2">
                        {{ pedido.dadospedido.enderecofaturamento.rua }},
                        {{ pedido.dadospedido.enderecofaturamento.numero }},
                        {{ pedido.dadospedido.enderecofaturamento.bairro }},
                        {{ pedido.dadospedido.enderecofaturamento.cep }},
                        {{ pedido.dadospedido.enderecofaturamento.cidade }},
                        {{ pedido.dadospedido.enderecofaturamento.complemento }}
                      </p>
                      <FormButton
                        icon
                        class="ml-3"
                        @click="openAddressDialog('Faturamento')"
                        v-if="showPrint"
                      >
                        <v-icon size="18" color="primario">
                          fa-edit
                        </v-icon>
                      </FormButton>
                    </v-row>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Endereço de entrega</td>
                  <td>
                    <v-row no-gutters>
                      <p
                        class="mb-2 mt-3"
                        v-if="
                          pedido.dadospedido.enderecoentrega &&
                            pedido.dadospedido.enderecoentrega.rua &&
                            pedido.dadospedido.enderecoentrega.bairro
                        "
                      >
                        {{ pedido.dadospedido.enderecoentrega.rua }},
                        {{ pedido.dadospedido.enderecoentrega.numero }},
                        {{ pedido.dadospedido.enderecoentrega.bairro }},
                        {{ pedido.dadospedido.enderecoentrega.cep }},
                        {{ pedido.dadospedido.enderecoentrega.cidade }},
                        {{ pedido.dadospedido.enderecoentrega.complemento }}
                      </p>
                      <p class="mb-2 mt-3" v-else>Endereço não informado</p>
                      <FormButton
                        icon
                        class="ml-3 mt-1"
                        @click="openAddressDialog('Entrega')"
                        v-if="showPrint"
                      >
                        <v-icon size="18" color="primario">
                          fa-edit
                        </v-icon>
                      </FormButton>
                    </v-row>
                  </td>
                </tr>
                <tr
                  v-if="
                    pedido.forma_entrega &&
                      pedido.forma_entrega.freteContratado &&
                      pedido.forma_entrega.freteContratado.rastreio
                  "
                >
                  <td class="font-weight-bold">Link de rastreio</td>
                  <td>
                    <a
                      :href="pedido.forma_entrega.freteContratado.rastreio"
                      target="_blank"
                    >
                      {{ pedido.forma_entrega.freteContratado.idFrete }}
                    </a>
                  </td>
                </tr>
                <tr
                  v-if="
                    pedido.forma_entrega && pedido.forma_entrega.urlEtiqueta
                  "
                >
                  <td class="font-weight-bold">Link da Etiqueta</td>
                  <td>
                    <a :href="pedido.forma_entrega.urlEtiqueta" target="_blank">
                      Baixar
                    </a>
                  </td>
                </tr>
                <tr v-if="detalhesPagamento && detalhesPagamento.isBoleto">
                  <td class="font-weight-bold">Detalhes do pagamento</td>
                  <td>
                    <a
                      v-if="detalhesPagamento.boletoUrl"
                      :href="detalhesPagamento.boletoUrl"
                      target="_blank"
                    >
                      Acessar boleto
                    </a>
                    <v-row v-else no-gutters>
                      <a href="#" @click="generateReceipt()">
                        Gerar boleto
                      </a>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="ml-3"
                            >far fa-question-circle</v-icon
                          >
                        </template>
                        Gera novamente o boleto para o pedido. Utilize somente
                        se o boleto foi gerado de forma incorreta.
                      </v-tooltip>
                    </v-row>
                  </td>
                </tr>
                <tr
                  v-if="
                    detalhesPagamento &&
                      detalhesPagamento.isPix &&
                      !detalhesPagamento.pixPayload
                  "
                >
                  <td class="font-weight-bold">Detalhes do pagamento</td>
                  <td>
                    <v-row no-gutters>
                      <a href="#" @click="generateReceipt()">
                        Gerar pagamento PIX
                      </a>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" class="ml-3"
                            >far fa-question-circle</v-icon
                          >
                        </template>
                        Em caso de falha, utilize essa opção para gerar o QRCode
                        de pagamento PIX.
                      </v-tooltip>
                    </v-row>
                  </td>
                </tr>
                <tr
                  v-if="
                    pedido.forma_entrega && pedido.forma_entrega.idformaentrega
                  "
                >
                  <td class="font-weight-bold">Forma de entrega</td>
                  <td>
                    <v-row no-gutters v-if="formasEntregas.length && showPrint">
                      <v-col>
                        <FormSelect
                          class="mt-3"
                          v-model="pedido.forma_entrega.idformaentreganome"
                          @input="changeDeliveryMethod"
                          :options="formasEntregas"
                          :disabled="!formaEntregaShow"
                          dense
                        />
                      </v-col>
                      <v-col cols="auto">
                        <FormButton
                          icon
                          class="mx-3 mt-4"
                          @click="showFormaEntrega()"
                          v-if="showPrint"
                        >
                          <v-icon size="18" color="primario">
                            fa-edit
                          </v-icon>
                        </FormButton>
                      </v-col>
                    </v-row>
                    <span
                      v-else-if="
                        pedido.forma_entrega && pedido.forma_entrega.nome
                      "
                      >{{ pedido.forma_entrega.nome }}</span
                    >
                  </td>
                </tr>
                <tr
                  v-if="
                    pedido.forma_entrega &&
                      pedido.forma_entrega.idcalendarioentrega
                  "
                >
                  <td class="font-weight-bold">Data e hora combinada</td>
                  <td>
                    <v-row no-gutters v-if="showPrint">
                      <FormDatetimePicker
                        class="mt-3"
                        v-model="pedido.dataentregatimestamp"
                        dense
                      />
                    </v-row>
                    <span v-else>{{ pedido.dataentregatimestamp }}</span>
                  </td>
                </tr>
                <tr
                  v-if="
                    pedido.responsavel_atendimento &&
                      pedido.responsavel_atendimento.responsavel.atendimento
                  "
                >
                  <td class="font-weight-bold">Responsável pelo pedido</td>
                  <td>
                    <v-row no-gutters>
                      <FormSelect
                        class="mt-3"
                        v-model="
                          pedido.responsavel_atendimento.responsavel.atendimento
                            .idusuario
                        "
                        @input="changeResponsable"
                        :options="usuarios"
                        :disabled="!respAtendimentoShow"
                        dense
                        :messages="
                          !showPrint ||
                          pedido.responsavel_atendimento.responsavel.atendimento
                            .idusuario
                            ? ''
                            : 'Responsável pelo pedido não definido.'
                        "
                      />
                      <FormButton
                        icon
                        class="mx-3 mt-4"
                        @click="respAtendimentoShow = !respAtendimentoShow"
                        v-if="showPrint"
                      >
                        <v-icon size="18" color="primario">
                          fa-edit
                        </v-icon>
                      </FormButton>
                    </v-row>
                  </td>
                </tr>
                <tr
                  v-if="
                    pedido.responsavel_atendimento &&
                      pedido.responsavel_atendimento.responsavel.separacao
                  "
                >
                  <td class="font-weight-bold">Responsável pela separação</td>
                  <td>
                    <v-row no-gutters>
                      <FormSelect
                        class="mt-3"
                        v-model="
                          pedido.responsavel_atendimento.responsavel.separacao
                            .idusuario
                        "
                        @input="changeResponsable"
                        :options="usuarios"
                        :disabled="!respSeparacaoShow"
                        dense
                        :messages="
                          !showPrint ||
                          pedido.responsavel_atendimento.responsavel.separacao
                            .idusuario
                            ? ''
                            : 'Responsável pela separação não definido.'
                        "
                      />
                      <FormButton
                        icon
                        class="mx-3 mt-4"
                        @click="respSeparacaoShow = !respSeparacaoShow"
                        v-if="showPrint"
                      >
                        <v-icon size="18" color="primario">
                          fa-edit
                        </v-icon>
                      </FormButton>
                    </v-row>
                  </td>
                </tr>
                <tr
                  v-if="
                    pedido.responsavel_atendimento &&
                      pedido.responsavel_atendimento.responsavel.entrega
                  "
                >
                  <td class="font-weight-bold">Responsável pela entrega</td>
                  <td>
                    <v-row no-gutters>
                      <FormSelect
                        class="mt-3"
                        v-model="
                          pedido.responsavel_atendimento.responsavel.entrega
                            .idusuario
                        "
                        @input="changeResponsable"
                        :options="usuarios"
                        :disabled="!respEntregaShow"
                        dense
                        :messages="
                          !showPrint ||
                          pedido.responsavel_atendimento.responsavel.entrega
                            .idusuario
                            ? ''
                            : 'Responsável pela entrega não definido.'
                        "
                      />
                      <FormButton
                        icon
                        class="mx-3 mt-4"
                        @click="respEntregaShow = !respEntregaShow"
                        v-if="showPrint"
                      >
                        <v-icon size="18" color="primario">
                          fa-edit
                        </v-icon>
                      </FormButton>
                    </v-row>
                  </td>
                </tr>
                <tr v-if="pedido.representante && showPrint">
                  <td class="font-weight-bold">Representante do Pedido</td>
                  <td>{{ pedido.representante }}</td>
                </tr>
                <tr v-if="pedido.usuario_vinculado && showPrint">
                  <td class="font-weight-bold">Usuário do Pedido</td>
                  <td>{{ pedido.usuario_vinculado }}</td>
                </tr>
                <tr v-if="pedido.nome_atendente && showPrint">
                  <td class="font-weight-bold">Responsável pela venda</td>
                  <td>{{ pedido.nome_atendente }}</td>
                </tr>
                <tr v-if="showPrint">
                  <td class="font-weight-bold">Tipo de entrega</td>
                  <td v-if="pedido.tipo_entrega === 'DELIVERY'">Delivery</td>
                  <td v-if="pedido.tipo_entrega === 'RETIRADA'">
                    Retirada na loja
                  </td>
                </tr>
                <tr v-for="(p, i) in pedido.caracteristicas" :key="i">
                  <td class="font-weight-bold">{{ p.nome }}</td>
                  <td v-if="p.tipo === 'boolean'">
                    {{ p.descricao === "true" ? "Sim" : "Não" }}
                  </td>
                  <td v-else>{{ p.descricao }}</td>
                </tr>
                <tr v-if="pedido.dadospedido && pedido.dadospedido.anotacoes">
                  <td class="font-weight-bold">Anotações do cliente</td>
                  <td>{{ pedido.dadospedido.anotacoes }}</td>
                </tr>
                <tr v-if="pedido.tipo_entrega === 'RETIRADA'">
                  <td class="font-weight-bold">{{ labelEndereco }}</td>
                  <td>{{ textEndereco }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </Panel>
        <Panel class="mt-5" lineColor="var(--primary-color)">
          <v-row no-gutters>
            <h4 class="text-start">
              Itens
            </h4>
            <v-icon class="ml-auto" v-if="showItens" @click="showItens = false">
              fa-chevron-up
            </v-icon>
            <v-icon class="ml-auto" v-else @click="showItens = true">
              fa-chevron-down
            </v-icon>
          </v-row>
          <LineDivider v-if="showItens" />
          <PedidoItens
            :pedido="pedido"
            v-if="showItens"
            :showPrint="showPrint"
            @realod-order="getData"
          ></PedidoItens>
        </Panel>
      </v-col>
      <v-col cols="12" md="4" class="mt-10">
        <Panel class="mt-6" lineColor="var(--primary-color)">
          <v-row no-gutters>
            <h4 class="text-start">
              Ações
            </h4>
            <v-icon class="ml-auto" v-if="showAcoes" @click="showAcoes = false">
              fa-chevron-up
            </v-icon>
            <v-icon class="ml-auto" v-else @click="showAcoes = true">
              fa-chevron-down
            </v-icon>
          </v-row>
          <LineDivider v-if="showAcoes" />
          <PedidoAcoes
            v-if="showAcoes"
            :pedido="pedido"
            @enviar-msg-chat="enviarMsgChat"
          />
        </Panel>
        <Panel
          class="mt-5"
          lineColor="var(--primary-color)"
          v-if="itensCortados.length > 0"
        >
          <v-row no-gutters>
            <h4 class="text-start">
              Itens cortados
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon size="18" v-on="on" class="ml-3">
                    far fa-question-circle
                  </v-icon>
                </template>
                Os produtos são exibidos nessa seção quando foram cortados,
                contém restrições e/ou o pedido teve algum erro de integração!
              </v-tooltip>
            </h4>
            <v-icon
              class="ml-auto"
              v-if="showItensCortados"
              @click="showItensCortados = false"
            >
              fa-chevron-up
            </v-icon>
            <v-icon class="ml-auto" v-else @click="showItensCortados = true">
              fa-chevron-down
            </v-icon>
          </v-row>
          <template v-if="showItensCortados">
            <LineDivider class="mb-n5" />
            <v-simple-table scrollable height="250" fixed-header>
              <thead>
                <tr>
                  <th>Descrição</th>
                  <th>Código</th>
                  <th class="text-center">Quantidade</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in itensCortados" :key="i">
                  <td class="text-start">{{ item.nome || item.nome_combo }}</td>
                  <td class="text-start">
                    {{
                      item.id_erp ||
                        item.id_produto_erp ||
                        item.id_combopromocional_erp ||
                        "sem código interno"
                    }}
                  </td>
                  <td>{{ item.quantidade }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <LineDivider class="mb-n4" />
            <FormButton class="px-10" @click="detailDialog = true">
              Ver detalhes
            </FormButton>
          </template>
        </Panel>
        <Panel class="mt-5" lineColor="var(--primary-color)">
          <v-row no-gutters>
            <h4 class="text-start">
              Chat
            </h4>
            <v-icon class="ml-auto" v-if="showChat" @click="showChat = false">
              fa-chevron-up
            </v-icon>
            <v-icon class="ml-auto" v-else @click="showChat = true">
              fa-chevron-down
            </v-icon>
          </v-row>
          <LineDivider v-if="showChat" class="mb-n5" />
          <PedidoChat
            ref="pedidoChat"
            v-if="showChat"
            :pedido="pedido"
          ></PedidoChat>
        </Panel>
        <Panel class="mt-5" lineColor="var(--primary-color)">
          <v-row no-gutters>
            <h4 class="text-start">
              Avaliação
            </h4>
            <v-icon
              class="ml-auto"
              v-if="showAvaliacao"
              @click="showAvaliacao = false"
            >
              fa-chevron-up
            </v-icon>
            <v-icon class="ml-auto" v-else @click="showAvaliacao = true">
              fa-chevron-down
            </v-icon>
          </v-row>
          <LineDivider v-if="showAvaliacao" />
          <span v-if="avaliacao">
            <h4 class="mb-2">{{ avaliacoes[avaliacao.nota].text }}</h4>
            <p v-if="avaliacao.comentario" class="font-italic px-5">
              "{{ avaliacao.comentario }}"
            </p>
            <span style="font-size: 3em;">{{
              avaliacoes[avaliacao.nota].smile
            }}</span>
          </span>
          <span v-else>Esta compra ainda não foi avaliada</span>
        </Panel>
        <Panel
          class="mt-5"
          lineColor="var(--primary-color)"
          v-if="showCancelButton && !lockControlsIntegrationOrder"
        >
          <v-row no-gutters>
            <h4 class="text-start">
              Cancelamento do pedido/orçamento
            </h4>
            <v-icon
              class="ml-auto"
              v-if="showCancelamento"
              @click="showCancelamento = false"
            >
              fa-chevron-up
            </v-icon>
            <v-icon class="ml-auto" v-else @click="showCancelamento = true">
              fa-chevron-down
            </v-icon>
          </v-row>
          <LineDivider v-if="showCancelamento" />
          <FormButton
            type="error"
            class="px-10 font-weight-bold"
            @click="cancelarPedido"
          >
            Cancelar
          </FormButton>
        </Panel>
      </v-col>
    </v-row>
    <v-dialog v-model="addressDialog" max-width="600px">
      <v-card>
        <v-card-title class="pa-4">
          <span class="text-h5"
            >Editar Endereço de {{ formAddress.title }}</span
          >
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <FormField
            label="Cep"
            v-model="formAddress.cep"
            :validation="$v.formAddress.cep"
            mask="#####-###"
          />
          <FormSelect
            v-if="usesGenericForeignDocument"
            label="País"
            v-model="formAddress.pais"
            :options="countries"
          />
          <FormField
            v-if="isForeignCountry"
            label="Estado"
            v-model="formAddress.uf"
            :validation="$v.formAddress.uf"
            maxLength="2"
          />
          <FormSelect
            v-if="!isForeignCountry"
            label="Estado"
            v-model="formAddress.uf"
            :validation="$v.formAddress.uf"
            :options="brazilianStates"
          />
          <FormField
            label="Cidade"
            v-model="formAddress.cidade"
            :validation="$v.formAddress.cidade"
          />
          <FormField
            label="Rua"
            v-model="formAddress.rua"
            :validation="$v.formAddress.rua"
          />
          <FormField
            label="Número"
            v-model="formAddress.numero"
            :validation="$v.formAddress.numero"
          />
          <FormField
            label="Bairro"
            v-model="formAddress.bairro"
            :validation="$v.formAddress.bairro"
          />
          <FormField
            label="Complemento"
            :disabled="formAddress.naotemcomplemento"
            v-model="formAddress.complemento"
            :validation="$v.formAddress.complemento"
          />
          <FormSwitch
            v-model="formAddress.naotemcomplemento"
            label="Não tem complemento"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <FormButton
            text="Fechar"
            type="error"
            @click="addressDialog = false"
          />
          <FormButton text="Salvar" @click="updateAddress(formAddress.title)" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="1200px" scrollable>
      <PedidoDetalhamento :pedido="pedido">
        <template>
          <v-card-actions class="pa-4">
            <v-spacer />
            <FormButton
              text="Fechar"
              type="error"
              @click="detailDialog = false"
            />
          </v-card-actions>
        </template>
      </PedidoDetalhamento>
    </v-dialog>
    <v-dialog
      v-model="eventDialog"
      scrollable
      content-class="pedido-eventos-dialog"
      :dark="darkEnabled"
    >
      <v-card max-height="84vh" :dark="darkEnabled">
        <v-card-title class="pa-4">
          <span class="text-h5 font-weight-bold">Eventos do pedido</span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4 text-start">
          <v-alert
            :type="darkEnabled ? 'secondary' : 'info'"
            :dark="darkEnabled"
          >
            Esse pedido existe no seu ERP com o número:
            <span class="font-weight-bold ml-3" v-if="logs.id_pedido_erp">
              {{ logs.id_pedido_erp }}
            </span>
          </v-alert>
          <v-tabs fixed-tabs v-model="tab" class="pedido-eventos-tabs">
            <v-tab>
              Pagamento
            </v-tab>
            <v-tab>
              Antifraude
            </v-tab>
            <v-tab>
              Integração
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" :dark="darkEnabled">
            <v-tab-item>
              <v-card flat :dark="darkEnabled">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" class="text-end">
                      <FormButton
                        v-if="emAnalise"
                        type="primario"
                        text="Reavaliação de pagamento"
                        class="mr-3"
                        :loading="isLoading"
                        @click="reanalisePaymentPending()"
                      />
                      <FormButton
                        type="primario"
                        text="Acessar tela de pagamento"
                        class="mr-3"
                        to="/fornecedor/pagamentos"
                      />
                      <FormButton
                        @click="linkAjuda()"
                        type="secundario"
                        text="Ajuda"
                      />
                    </v-col>
                    <v-col>
                      <v-simple-table dense>
                        <thead>
                          <tr>
                            <th>Data</th>
                            <th>Código</th>
                            <th>Ação</th>
                            <th>Valor</th>
                            <th>Mensagem</th>
                          </tr>
                        </thead>
                        <tbody
                          v-if="
                            logs.eventos_pagamento &&
                              logs.eventos_pagamento.length > 0
                          "
                        >
                          <tr
                            v-for="ev in logs.eventos_pagamento"
                            :key="ev.tid"
                          >
                            <td>{{ ev.date | formatDateTime(getTimeZone) }}</td>
                            <td>
                              <code>{{ ev.type }} {{ ev.code }}</code>
                            </td>
                            <td>
                              {{
                                aliasActionLabel[ev.actionalias] || "Transação"
                              }}
                            </td>
                            <td>{{ (ev.amount / 100) | formatMoney }}</td>
                            <td>
                              <span style="display: block;">{{
                                ev.message
                              }}</span>
                              <span style="display: block;">{{
                                ev.submessage
                              }}</span>
                              <span style="display: block;">{{ ev.log }}</span>
                              <v-simple-table
                                v-if="hadSequencialAcao(ev.sequencialacao)"
                              >
                                <thead>
                                  <tr>
                                    <th>Ação</th>
                                    <th>Sequencial/NSU</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(sa, i) in ev.sequencialacao"
                                    :key="i"
                                  >
                                    <td>
                                      {{
                                        aliasActionLabel[
                                          sa.acao.toLocaleLowerCase()
                                        ] || "Transação"
                                      }}
                                    </td>
                                    <td>{{ sa.sequencial }}</td>
                                  </tr>
                                </tbody>
                              </v-simple-table>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="5" class="text-center">
                              Nenhum registro encontrado
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat :dark="darkEnabled">
                <v-card-text
                  ><v-row>
                    <v-col cols="12" class="text-end">
                      <FormButton
                        v-if="emAnalise"
                        type="primario"
                        text="Reavaliação de pagamento"
                        class="mr-3"
                        :loading="isLoading"
                        @click="reanalisePaymentPending()"
                      />
                      <FormButton
                        type="primario"
                        text="Acessar tela de pagamento"
                        class="mr-3"
                        to="/fornecedor/pagamentos"
                      />
                      <FormButton
                        @click="linkAjuda()"
                        type="secundario"
                        text="Ajuda"
                      />
                    </v-col>
                    <v-col>
                      <v-simple-table dense>
                        <thead>
                          <tr>
                            <th>Data</th>
                            <th>Código</th>
                            <th>Mensagem</th>
                          </tr>
                        </thead>
                        <tbody
                          v-if="
                            logs.eventos_antifraude &&
                              logs.eventos_antifraude.length > 0
                          "
                        >
                          <tr
                            v-for="ev in logs.eventos_pagamento"
                            :key="ev.tid"
                          >
                            <td>{{ ev.date | formatDateTime(getTimeZone) }}</td>
                            <td>
                              <code>{{ ev.code }}</code>
                            </td>
                            <td>Antifraude: {{ ev.message }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="3" class="text-center">
                              Nenhum registro encontrado
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat :dark="darkEnabled">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" class="text-end">
                      <small
                        v-if="aguardandoPagamento"
                        class="mr-3 font-weight-bold"
                      >
                        Pedidos em aguardando pagamento não podem ser enviados
                        ao ERP.
                      </small>
                      <FormButton
                        type="error"
                        text="Reenviar para o ERP"
                        :disabled="aguardandoPagamento"
                        :loading="isLoading"
                        @click="reenviarErp()"
                      />
                    </v-col>
                    <v-col>
                      <v-simple-table dense>
                        <thead>
                          <tr>
                            <th>Data</th>
                            <th>Código</th>
                            <th>Mensagem</th>
                            <th class="text-center">Objeto</th>
                          </tr>
                        </thead>
                        <tbody
                          v-if="logs.eventos_erp && logs.eventos_erp.length > 0"
                        >
                          <tr v-for="(ev, i) in logs.eventos_erp" :key="i">
                            <td>{{ ev.date | formatDateTime(getTimeZone) }}</td>
                            <td>
                              <code>{{ ev.code }}</code>
                            </td>
                            <td
                              v-html="ev.message.replaceAll('\n', '</br>')"
                            ></td>
                            <td>
                              <v-row>
                                <v-col cols="12" class="text-center">
                                  <template v-if="ev.event_object">
                                    <FormButton
                                      icon
                                      class="mr-3"
                                      @click="copyToClipboard(ev.event_object)"
                                    >
                                      <v-icon>fa-clone</v-icon>
                                    </FormButton>
                                    <FormButton
                                      icon
                                      class="mr-3"
                                      @click="
                                        downloadJson(ev.code, ev.event_object)
                                      "
                                    >
                                      <v-icon>fa-download</v-icon>
                                    </FormButton>
                                    <FormButton
                                      v-if="!ev.show"
                                      icon
                                      @click="ev.show = true"
                                    >
                                      <v-icon>fa-eye</v-icon>
                                    </FormButton>
                                    <FormButton
                                      v-else
                                      icon
                                      @click="ev.show = false"
                                    >
                                      <v-icon>fa-eye-slash</v-icon>
                                    </FormButton>
                                  </template>
                                </v-col>
                                <v-col cols="12">
                                  <code v-if="ev.show">
                                    {{ ev.event_object }}
                                  </code>
                                </v-col>
                              </v-row>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="4" class="text-center">
                              Nenhum registro encontrado
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <FormButton text="Fechar" type="error" @click="eventDialog = false" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import MarketingModules from "@/components/MarketingModules";
import LineDivider from "@/components/LineDivider";
import FormButton from "@/components/form/FormButton";
import FormSelect from "@/components/form/FormSelect";
import FormRadioGroup from "@/components/form/FormRadioGroup";
import FormField from "@/components/form/FormField";
import FormDatetimePicker from "@/components/form/FormDatetimePicker";
import FormSwitch from "@/components/form/FormSwitch";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import { mapGetters } from "vuex";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import OrderStatus from "../../../utils/orderStatus";
import {
  PEDIDO_LOAD,
  PEDIDO_DISABLE_BLOCK_PAYMENT,
  PEDIDO_UPDATE_PAYMENT_CHECK,
  PEDIDO_UPDATE_PAYMENT_METHOD,
  PEDIDO_UPDATE_DELIVEY_METHOD,
  PEDIDO_UPDATE_ADDRESS,
  PEDIDO_GENERATE_RECEIPT,
  PEDIDO_LOAD_DELIVEY_METHODS,
  PEDIDO_UPDATE_DELIVEY_DATE,
  PEDIDO_UPDATE_RESPONSABLE,
  PEDIDO_LOAD_LOGS,
  PEDIDO_RESEND_ERP,
  PEDIDO_PAYMENT_PENDING,
  PEDIDO_CANCEL,
  PEDIDO_AVALIATION,
  PEDIDO_AVALIACOES,
  PEDIDO_EXPORT_DETALHE
} from "@/store/actions/pedido";
import { CLIENTE_LOAD_PAYMENT_METHODS } from "@/store/actions/cliente";
import { USUARIO_LOAD_ALL } from "@/store/actions/usuario";
import * as _ from "lodash";
import locationsMixin from "@/mixins/locations";
import { required } from "vuelidate/lib/validators";
import PedidoDetalhamento from "./components/PedidoDetalhamento";
import PedidoItens from "./components/PedidoItens";
import PedidoAcoes from "./components/PedidoAcoes";
import PedidoChat from "./components/PedidoChat";
import { setTimeout } from "timers";

export default {
  name: "PedidoTable",
  mixins: [locationsMixin],
  components: {
    Panel,
    MarketingModules,
    LineDivider,
    FormButton,
    FormSelect,
    FormRadioGroup,
    FormField,
    FormDatetimePicker,
    FormSwitch,
    FormButtonGroup,
    PedidoDetalhamento,
    PedidoItens,
    PedidoAcoes,
    PedidoChat
  },
  data: () => ({
    showPrint: true,
    showItens: true,
    showAcoes: true,
    showChat: true,
    showItensCortados: true,
    showAvaliacao: true,
    showCancelamento: true,
    isLoading: false,
    isLoadingPrint: false,
    addressDialog: false,
    detailDialog: false,
    eventDialog: false,
    formAddress: {},
    pedido: {},
    avaliacao: {},
    avaliacoes: PEDIDO_AVALIACOES,
    logs: {},
    tab: 0,
    formasPagamento: [],
    formasEntregas: [],
    usuarios: [],
    formaPgtoExiste: true,
    formaPgtoShow: false,
    parcelaShow: false,
    formaEntregaShow: false,
    respEntregaShow: false,
    respAtendimentoShow: false,
    respSeparacaoShow: false,
    modulosForm: [
      ModulesEnum.PAINEL_CLIENTE,
      ModulesEnum.ORCAMENTO_WEB,
      ModulesEnum.ORCAMENTO_APP,
      ModulesEnum.VENDAMAIS_WEB,
      ModulesEnum.VENDAMAIS_APP,
      ModulesEnum.WEB_COMMERCE,
      ModulesEnum.COMMERCE_APP
    ],
    aliasActionLabel: {
      transaction: "Transação",
      capture: "Captura",
      estorno: "Estorno",
      status: "Status"
    },
    paymentManual: [
      {
        label: "Aprovado manualmente (não utilizar recomendação do antifraude)",
        value: true
      },
      { label: "Definada pelo antifraude", value: false }
    ]
  }),
  validations: {
    formAddress: {
      rua: { required },
      numero: { required },
      bairro: { required },
      pais: { required },
      uf: { required },
      cidade: { required },
      cep: { required }
    }
  },
  computed: {
    ...mapGetters([
      "getFornecedorId",
      "getFornecedorTag",
      "moduloFornecedorAtivo",
      "getTimeZone",
      "getUsuarioId",
      "darkEnabled"
    ]),
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    },
    commerceAtivo() {
      return this.moduloFornecedorAtivo([
        ModulesEnum.WEB_COMMERCE,
        ModulesEnum.COMMERCE_APP
      ]);
    },
    parcelas() {
      const parcelas = [];
      for (let i = 1; i <= 48; i++) {
        parcelas.push({
          value: i,
          text: `${i === 1 ? "à Vista" : i + " parcelas"}`
        });
      }
      return parcelas;
    },
    isForeignCountry() {
      return this.formAddress.pais !== "Brasil";
    },
    usesGenericForeignDocument() {
      return this.getFornecedorTag["uses-generic-foreign-document"];
    },
    detalhesPagamento() {
      const data = _.get(this.pedido, "pagamento_sucesso", null);
      const type = _.get(data, "Tipo", null);
      if (type) {
        const boletoUrl = _.get(data, "Boleto.Url", "");
        const pixPayload = _.get(data, "Pix.Payload", "");
        return {
          boletoUrl,
          pixPayload,
          isCredito: type === "CREDITO",
          isBoleto: type === "BOLETO",
          isPix: type === "PIX",
          type
        };
      }
      return null;
    },
    emAnalise() {
      return _.get(this.pedido, "pagamento_pendente.StatusCode") === "Pending";
    },
    aguardandoPagamento() {
      return (
        this.logs.statuspedido &&
        this.logs.statuspedido == "AGUARDANDOPAGAMENTO"
      );
    },
    showCancelButton() {
      return (
        this.pedido.statuspedido !== OrderStatus.OrderStatus.ENTREGUE &&
        this.pedido.statuspedido !== OrderStatus.OrderStatus.CANCELADO &&
        this.moduloFornecedorAtivo(this.modulosForm)
      );
    },
    lockControlsIntegrationOrder() {
      const acaoManual =
        this.finishOrderManually &&
        (this.pedido.statuspedido === OrderStatus.OrderStatus.SEPARANDO ||
          this.pedido.statuspedido === OrderStatus.OrderStatus.PAGO ||
          this.pedido.statuspedido ===
            OrderStatus.OrderStatus.PRONTO_RETIRADA ||
          this.pedido.statuspedido === OrderStatus.OrderStatus.EMENTREGA ||
          this.pedido.statuspedido === OrderStatus.OrderStatus.ENTREGUE);
      return !acaoManual && this.pedido.id_pedido_erp;
    },
    getPagamentoBoleto() {
      const tipo = _.get(this.pedido, "dadospedido.formaPagamento.tipo");
      return tipo === "BOLETO";
    },
    getPagamentoDebito() {
      const tipo = _.get(this.pedido, "dadospedido.formaPagamento.tipo");
      return tipo === "DEBITO";
    },
    getFormaPagamento() {
      const idformapagto = _.get(
        this.pedido,
        "dadospedido.formaPagamento.idformapagto"
      );
      return this.formasPagamento.find(f => f.value === idformapagto);
    },
    getParcela() {
      const quantParcelas = _.get(
        this.pedido,
        "dadospedido.formaPagamento.quantParcelas"
      );
      return this.parcelas.find(f => f.value === quantParcelas);
    },
    labelEndereco() {
      return this.pedido.tipo_entrega === "DELIVERY"
        ? "Endereço de entrega"
        : "Loja para retirada";
    },
    textEndereco() {
      let enderecoText = "";
      const {
        dadospedido: {
          enderecoentrega: { textoendereco } = {},
          lojaRetira: { nome = "", descricao_endereco_loja = "" } = {}
        } = {},
        tipo_entrega = ""
      } = this.pedido;
      if (tipo_entrega === "DELIVERY" && textoendereco) {
        enderecoText = textoendereco;
      } else if (tipo_entrega && nome) {
        enderecoText = `${nome} ${descricao_endereco_loja}`;
      }
      return enderecoText;
    },
    itensCortados() {
      return this.pedido.dadospedido && this.pedido.dadospedido.itensCortados
        ? this.pedido.dadospedido.itensCortados.filter(
            item => item.tipo_produto !== "CONJUNTO"
          )
        : [];
    }
  },
  methods: {
    getData(numpedido) {
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_LOAD, numpedido)
        .then(data => {
          this.pedido = data;
          this.pedido.dadospedido = this.pedido.dadospedido || {
            formaPagamento: {
              idformapagto: null,
              tipo: null,
              quantParcelas: 1
            },
            enderecoentrega: {},
            lojaRetira: {}
          };
          this.pedido.totalliquido = parseFloat(
            this.pedido.totalliquido || 0
          ).toFixed(2);
          this.pedido.totalpedido = parseFloat(
            this.pedido.totalpedido || 0
          ).toFixed(2);
          this.pedido.dadospedido.manualPaymentVerified =
            this.pedido.dadospedido.manualPaymentVerified || false;
          const parcelas = _.get(
            data,
            "dadospedido.formaPagamento.quantParcelas",
            1
          );
          const qtdParcela =
            typeof parcelas === "string" ? Number(parcelas) : parcelas;
          this.pedido.dadospedido.formaPagamento.quantParcelas = qtdParcela;
          this.pedido.dataentregatimestamp = new Date(
            this.pedido.dataentregatimestamp * 1000
          ).toISOString();
          if (
            !(
              this.pedido.responsavel_atendimento &&
              this.pedido.responsavel_atendimento.responsavel
            )
          ) {
            this.pedido.responsavel_atendimento = {
              responsavel: {
                atendimento: { idusuario: null },
                separacao: { idusuario: null },
                entrega: { idusuario: null }
              }
            };
          }
          if (!this.pedido.responsavel_atendimento.responsavel.atendimento) {
            this.pedido.responsavel_atendimento.responsavel.atendimento = {
              idusuario: null
            };
          }
          if (!this.pedido.responsavel_atendimento.responsavel.entrega) {
            this.pedido.responsavel_atendimento.responsavel.entrega = {
              idusuario: null
            };
          }
          if (!this.pedido.responsavel_atendimento.responsavel.separacao) {
            this.pedido.responsavel_atendimento.responsavel.separacao = {
              idusuario: null
            };
          }
          if (
            this.pedido.forma_entrega &&
            this.pedido.forma_entrega.idformaentrega &&
            this.pedido.forma_entrega.nome
          ) {
            this.pedido.forma_entrega.idformaentreganome = `${this.pedido.forma_entrega.idformaentrega}|${this.pedido.forma_entrega.nome}`;
            this.formasEntregas = [
              {
                ...this.pedido.forma_entrega,
                idformaentreganome: `${this.pedido.forma_entrega.idformaentrega}|${this.pedido.forma_entrega.nome}`,
                text: this.pedido.forma_entrega.nome,
                value: `${this.pedido.forma_entrega.idformaentrega}|${this.pedido.forma_entrega.nome}`
              }
            ];
          }
          this.isLoading = false;
          this.getPaymentMethods(this.pedido.idcliente);
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getPaymentMethods(idcliente) {
      this.isLoading = true;
      this.$store
        .dispatch(CLIENTE_LOAD_PAYMENT_METHODS, idcliente)
        .then(data => {
          if (
            this.pedido.dadospedido &&
            this.pedido.dadospedido.formaPagamento
          ) {
            const formaPagamento = this.pedido.dadospedido.formaPagamento;
            const exists = data.some(
              f => f.idformapagto === formaPagamento.idformapagto
            );
            if (!exists) {
              data.push(formaPagamento);
              this.formaPgtoExiste = false;
            }
          }
          this.formasPagamento = data.map(f => {
            return {
              ...f,
              text: f.descricao,
              value: f.idformapagto
            };
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getDeliveryMethods(pedido) {
      var idendereco = _.get(pedido, "dadospedido.enderecoentrega.idendereco");
      if (!idendereco) return;
      const data = {
        idendereco: idendereco,
        idpedido: pedido.idpedido,
        idcliente: pedido.idcliente
      };
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_LOAD_DELIVEY_METHODS, data)
        .then(data => {
          this.formaEntregaShow = true;
          const formaEntrega = this.pedido.forma_entrega;
          const exists = data.some(
            f =>
              f.idformaentrega === formaEntrega.idformaentrega &&
              f.nome === formaEntrega.nome
          );
          if (!exists) {
            data.push(formaEntrega);
          }
          this.formasEntregas = data.map(f => {
            return {
              ...f,
              idformaentreganome: `${f.idformaentrega}|${f.nome}`,
              text: f.nome,
              value: `${f.idformaentrega}|${f.nome}`
            };
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getUsers() {
      this.isLoading = true;
      this.$store
        .dispatch(USUARIO_LOAD_ALL)
        .then(data => {
          this.usuarios = data.users.map(u => {
            return {
              ...u,
              text: u.nome || u.nomeusuario,
              value: u.idusuario
            };
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    getStatusPedido(status) {
      return OrderStatus && OrderStatus.OrderStatusLabel
        ? OrderStatus.OrderStatusLabel[status]
        : "";
    },
    getStatusPedidoColor(status) {
      return OrderStatus && OrderStatus.OrderStatusColor
        ? OrderStatus.OrderStatusColor[status]
        : "";
    },
    callWhatsapp(telefone) {
      const formattedNumber = telefone.replace(/\D/g, "");
      const whatsappUrl = `https://wa.me/+55${formattedNumber}`;
      window.open(whatsappUrl, "_blank");
    },
    getBloqueioPagamento() {
      const ativo =
        _.get(this.pedido, "bloqueio_pagamento.ativo", false) || false;
      const desbloqueio_manual =
        _.get(this.pedido, "bloqueio_pagamento.desbloqueio_manual", false) ||
        false;
      const log = _.get(this.pedido, "bloqueio_pagamento.log", "") || "";
      return {
        ativo: ativo && !desbloqueio_manual,
        log
      };
    },
    desbloqueioPagamento() {
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_DISABLE_BLOCK_PAYMENT, this.pedido.numpedido)
        .then(() => {
          this.isLoading = false;
          this.getData(this.pedido.numpedido);
        })
        .catch(err => {
          const erro =
            err.response.data.Mensagem ||
            err.response.data ||
            "Erro ao desbloquear pagamento";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    setPedidoVerificadoManualmente(value) {
      this.isLoading = true;
      this.pedido.value = value;
      this.$store
        .dispatch(PEDIDO_UPDATE_PAYMENT_CHECK, this.pedido)
        .then(() => {
          this.isLoading = false;
          this.getData(this.pedido.numpedido);
        })
        .catch(err => {
          const erro =
            err.response.data.Mensagem ||
            err.response.data ||
            "Erro ao alterar verificação manual de pagamento";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    changePaymentMethod(value) {
      if (!value) return;
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_UPDATE_PAYMENT_METHOD, this.pedido)
        .then(() => {
          this.isLoading = false;
          this.$vueOnToast.pop(
            "success",
            "Forma de pagamento atualizada com sucesso"
          );
          this.formaPgtoShow = false;
          this.parcelaShow = false;
          this.getData(this.pedido.numpedido);
        })
        .catch(err => {
          const erro = err.error || "Falha ao atualizar forma de pagamento";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    showFormaEntrega() {
      if (this.formaEntregaShow) {
        this.formaEntregaShow = false;
        return;
      }
      this.getDeliveryMethods(this.pedido);
    },
    changeDeliveryMethod(value) {
      if (!value) return;
      const formaEntrega = this.formasEntregas.filter(
        fe => fe.idformaentreganome == value
      )[0];
      this.pedido.forma_entrega = formaEntrega;
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_UPDATE_DELIVEY_METHOD, this.pedido)
        .then(() => {
          this.isLoading = false;
          this.$vueOnToast.pop(
            "success",
            "Forma de entrega atualizada com sucesso"
          );
          this.formaEntregaShow = false;
          this.getData(this.pedido.numpedido);
        })
        .catch(err => {
          const erro = err.error || "Falha ao atualizar forma de entrega";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    changeResponsable(value) {
      if (!value) return;
      this.isLoading = true;
      const data = {
        idpedido: this.pedido.idpedido,
        responsavel: this.pedido.responsavel_atendimento.responsavel
      };
      this.$store
        .dispatch(PEDIDO_UPDATE_RESPONSABLE, data)
        .then(() => {
          this.isLoading = false;
          this.$vueOnToast.pop("success", "Responsável atualizado com sucesso");
          this.respAtendimentoShow = false;
          this.respEntregaShow = false;
          this.respSeparacaoShow = false;
          this.getData(this.pedido.numpedido);
        })
        .catch(err => {
          const erro = err.error || "Falha ao atualizar responsável";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    openAddressDialog(title) {
      if (title == "Faturamento") {
        this.formAddress = this.pedido.dadospedido.enderecofaturamento;
      } else {
        this.formAddress = this.pedido.dadospedido.enderecoentrega;
      }
      this.formAddress.title = title;
      this.addressDialog = true;
    },
    updateAddress(labelType) {
      if (labelType == "Faturamento") {
        this.pedido.dadospedido.enderecofaturamento = this.formAddress;
      } else {
        this.pedido.dadospedido.enderecoentrega = this.formAddress;
      }
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_UPDATE_ADDRESS, this.pedido)
        .then(() => {
          this.isLoading = false;
          this.$vueOnToast.pop(
            "success",
            `Endereço de ${labelType} atualizado com sucesso`
          );
          this.addressDialog = false;
          this.formAddress = {};
          this.getData(this.pedido.numpedido);
        })
        .catch(err => {
          const erro =
            err.response.data.Mensagem ||
            err.response.data ||
            `Falha ao atualizar endereço de ${labelType}`;
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    generateReceipt() {
      const msg = this.detalhesPagamento.isPix ? "Pagamento pix" : "Boleto";
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_GENERATE_RECEIPT, this.pedido)
        .then(() => {
          this.isLoading = false;
          this.$vueOnToast.pop("success", `${msg} gerado com sucesso`);
          this.getData(this.pedido.numpedido);
        })
        .catch(err => {
          const erro =
            err.response.data.Mensagem ||
            err.response.data ||
            `Não foi possível gerar o ${msg}`;
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    changeDeliverDate() {
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_UPDATE_DELIVEY_DATE, this.pedido)
        .then(() => {
          this.isLoading = false;
          this.$vueOnToast.pop(
            "success",
            "Data da entrega alterada com sucesso"
          );
          this.getData(this.pedido.numpedido);
        })
        .catch(err => {
          const erro =
            err.response.data.Mensagem ||
            err.response.data ||
            "Não foi possível atualizar a data de entrega";
          this.$vueOnToast.pop("error", erro);
          this.isLoading = false;
        });
    },
    getLogs() {
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_LOAD_LOGS, this.pedido.numpedido)
        .then(data => {
          this.logs = data;
          if (this.logs.eventos_erp) {
            this.logs.eventos_erp = this.logs.eventos_erp.map(ev => {
              return {
                ...ev,
                show: false
              };
            });
          }
          if (this.logs.eventos_pagamento) {
            this.logs.eventos_pagamento = this.logs.eventos_pagamento.map(
              item => ({
                ...item,
                id: item.tid + Math.random() * 1000,
                message: `Gateway: ${item.message || ""} ${
                  item.error_timeout
                    ? "(Resposta inesperada do gateway, favor consultar o provedor de pagamento)"
                    : ""
                }`,
                submessage: `${item.installments ||
                  1} parcelas | TID ${item.tid ||
                  ""} | Sequencial/NSU ${item.sequential || "--"} ${
                  item.bandeira ? " | Bandeira " + item.bandeira : ""
                }  | idPagamento: ${item.idpagamento || "--"}`
              })
            );
          }
          if (this.logs.eventos_estorno) {
            const logEstorno = (this.logs.eventos_estorno || []).map(item => ({
              ...item,
              id: item.referencia + Math.random() * 1000,
              type: "estorno",
              actionalias: "estorno",
              message: `Gateway: ${item.message || ""}`,
              submessage: `Ref.:${item.referencia ||
                ""} | IdPag.: ${item.idpagamento ||
                ""} | tipo estorno: ${item.type || ""}`,
              log: ""
            }));
            this.logs.eventos_pagamento = this.logs.eventos_pagamento.concat(
              logEstorno
            );
          }
          if (this.logs.eventos_firewall) {
            const logFirewall = (this.logs.eventos_firewall || []).map(
              item => ({
                ...item,
                id: item.referencia + Math.random() * 1000,
                type: "",
                actionalias: "bloqueio",
                message: `Proteções de seguranca: ${item.message || ""}`,
                submessage: `IP:${item.referencia || ""}`,
                log: ""
              })
            );
            this.logs.eventos_pagamento = this.logs.eventos_pagamento.concat(
              logFirewall
            );
          }
          this.logs.eventos_pagamento = _.sortBy(
            this.logs.eventos_pagamento,
            "date"
          );
          this.eventDialog = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    copyToClipboard(text) {
      const tempTextArea = document.createElement("textarea");
      tempTextArea.value = JSON.stringify(text);
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand("copy");
      document.body.removeChild(tempTextArea);
      this.$vueOnToast.pop(
        "success",
        `Texto copiado para a área de transferência`
      );
    },
    downloadJson(codigo, objeto) {
      const link = document.createElement("a");
      const data = new Blob([JSON.stringify(objeto)], {
        type: "application/json"
      });
      link.href = URL.createObjectURL(data);
      link.setAttribute("download", `${codigo}.json`);
      link.click();
      URL.revokeObjectURL(link.href);
      this.$vueOnToast.pop("success", "Download do arquivo iniciado.");
    },
    reenviarErp() {
      if (this.logs.statuspedido == "AGUARDANDOPAGAMENTO") {
        this.$vueOnToast.pop(
          "error",
          "Pedidos em aguardando pagamento não podem ser enviados ao ERP."
        );
        return;
      }
      let title = "Enviar para o ERP";
      let text = "Deseja enviar o pedido para o ERP?";
      if (this.logs.id_pedido_erp) {
        title = "Reenviar pedido para ERP";
        text = `Seu ERP já tem esse pedido com o número ${this.logs.id_pedido_erp}. O reenvio pode duplicá-lo no ERP. Deseja continuar?`;
      }
      const options = {
        text: text,
        title: title
      };
      this.confirmSwal(options, () => {
        this.isLoading = true;
        this.$store
          .dispatch(PEDIDO_RESEND_ERP, this.logs.idpedido)
          .then(() => {
            this.$vueOnToast.pop(
              "success",
              "Reenvio efetuado com sucesso. Verifique seu ERP."
            );
            this.isLoading = false;
            this.getLogs();
          })
          .catch(() => {
            this.$vueOnToast.pop(
              "error",
              "Falha ao executar reenvio para ERP."
            );
            this.isLoading = false;
            this.getLogs();
          });
      });
    },
    linkAjuda() {
      window.open(
        "https://lifeapps.atlassian.net/wiki/spaces/BC/pages/26346160/O+que+e+como+utilizar+o+estorno+de+pagamentos",
        "_blank"
      );
    },
    reanalisePaymentPending() {
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_PAYMENT_PENDING, this.pedido.numpedido)
        .then(data => {
          const { message = "", status = "Pending" } = data;
          if (status == "Approved") {
            this.$vueOnToast.pop(
              "success",
              message || "Pagamento aprovado pelo antifraude"
            );
            setTimeout(() => location.reload(), 1500);
          } else if (status == "Reproved") {
            this.$vueOnToast.pop(
              "error",
              message || "Pedido cancelado por recomendações do antifraude"
            );
            setTimeout(() => location.reload(), 1500);
          } else {
            this.$vueOnToast.pop(
              "success",
              message || "Pedido pendente de analise do antifraude"
            );
          }
          this.$vueOnToast.pop(
            "success",
            "Reenvio efetuado com sucesso. Verifique seu ERP."
          );
          this.isLoading = false;
        })
        .catch(() => {
          this.$vueOnToast.pop(
            "error",
            "Falha ao solicitar reanalise do antifraude"
          );
          this.isLoading = false;
        });
    },
    hadSequencialAcao(acaoSequencial) {
      return acaoSequencial && acaoSequencial.findIndex(a => a.sequencial) > -1;
    },
    printOrder() {
      if (!this.pedido || !this.pedido.idpedido) {
        this.$vueOnToast.pop("error", "Pedido não carregado");
        return;
      }
      this.isLoadingPrint = true;
      this.$vueOnToast.pop(
        "warning",
        "Gerando PDF, pode levar alguns segundos..."
      );
      this.$store
        .dispatch(PEDIDO_EXPORT_DETALHE, this.pedido.idpedido)
        .then(data => {
          const url = URL.createObjectURL(
            new Blob([data], { type: "application/pdf" })
          );
          window.open(url, "_blank");
        })
        .catch(err => {
          const mensagem =
            _.get(err, "response.data.message") ||
            _.get(err, "response.data.Mensagem") ||
            "Falha ao gerar PDF do pedido";
          this.$vueOnToast.pop("error", mensagem);
        })
        .finally(() => {
          this.isLoadingPrint = false;
        });
    },
    cancelarPedido() {
      const options = {
        title: "Confirma o cancelamento do pedido/orçamento?"
      };
      this.confirmSwal(options, () => {
        const formaPagamento = _.get(
          this.pedido,
          "dadospedido.formaPagamento.tipo"
        );
        if (["CREDITO", "DEBITO", "PIX"].includes(formaPagamento)) {
          this.$swal
            .fire({
              title: `Deseja realizar o estorno do valor do pedido?`,
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Sim",
              cancelButtonText: "Não",
              reverseButtons: true
            })
            .then(result => {
              if (result.value) {
                this.doCancelarPedido("true");
              } else {
                this.doCancelarPedido("false");
              }
            });
        } else {
          this.doCancelarPedido("false");
        }
      });
    },
    doCancelarPedido(estorno) {
      const data = {
        idcliente: this.pedido.idcliente,
        numpedido: this.pedido.numpedido,
        idusuario: this.getUsuarioId,
        estorno: estorno
      };
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_CANCEL, data)
        .then(() => {
          this.$vueOnToast.pop("success", "Pedido cancelado com sucesso");
          this.isLoading = false;
          setTimeout(() => location.reload(), 1500);
        })
        .catch(() => {
          this.$vueOnToast.pop("error", "Falha ao cancelar pedido");
          this.isLoading = false;
        });
    },
    getAvaliations(numpedido) {
      this.isLoading = true;
      this.$store
        .dispatch(PEDIDO_AVALIATION, numpedido)
        .then(data => {
          this.avaliacao = data.avaliacao;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    enviarMsgChat(data) {
      const mensagem = data.message;
      this.$refs.pedidoChat.enviarMensagem(mensagem, null);
    }
  },
  watch: {
    "pedido.dataentregatimestamp"(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.changeDeliverDate();
      }
    }
  },
  created() {
    let { numpedido } = this.$route.params;
    this.getData(numpedido);
    this.getAvaliations(numpedido);
    this.getUsers();
  }
};
</script>

<style lang="scss">
.badge-container {
  position: relative;
  padding-top: 10px;
  display: inline-block;
}
.badge {
  position: absolute;
  top: -20px;
  right: -30px;
  background-color: #7e7675;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 6px;
  font-size: 12px;
  min-width: 25px;
}

.v-application:not(.theme--dark) .pedido-eventos-dialog .pedido-eventos-tabs {
  .v-tabs-bar {
    background-color: var(--primary-color, #12558c) !important;
  }

  .v-tab {
    color: rgba(255, 255, 255, 0.75) !important;
  }

  .v-tab--active {
    color: #fff !important;
  }

  .v-tabs-slider {
    background-color: rgba(255, 255, 255, 0.9) !important;
  }
}

.v-application.theme--dark .pedido-eventos-dialog .pedido-eventos-tabs {
  .v-tabs-bar {
    background-color: var(--dark-page-bg, #424242) !important;
  }

  .v-tab {
    color: rgba(255, 255, 255, 0.65) !important;
  }

  .v-tab--active {
    color: rgba(255, 255, 255, 0.95) !important;
  }

  .v-tabs-slider {
    background-color: rgba(255, 255, 255, 0.85) !important;
  }
}
</style>
